import React from "react"
import fonts from "../../font-stacks"

const assignFallbacks = fontFamily => {
  const font = fonts.find(f => f.value === fontFamily)

  if (!font) {
    console.error(`Couldn't find fallbacks for the font "${fontFamily}".`)
    return fontFamily
  }

  return font.stack
}

export default ({ name, selector } = {}) => ({
  name,
  type: "font",
  component: ({ name: _name, value: _value, onChange }) => {
    return (
      <select
        onChange={onChange}
        className="w-full py-2 px-3 focus:outline-none focus:border-gray-500"
      >
        {fonts.map(option => (
          <option key={option.value} value={option.value}>{option.label || option.value}</option>
        ))}
      </select>
    )
  },
  css: value => {
    const font = assignFallbacks(value)
    return `
      ${selector} {
        font-family: ${font};
      }
    `
  }
})
